import script from "./TheoDoiVtptThuHoi.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheoDoiVtptThuHoi.vue?vue&type=script&lang=ts&setup=true"

import "./TheoDoiVtptThuHoi.vue?vue&type=style&index=0&id=0fc54d21&scoped=true&lang=css"
import "./TheoDoiVtptThuHoi.vue?vue&type=style&index=1&id=0fc54d21&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc54d21"]])

export default __exports__